import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Petition } from 'src/app/interfaces/petition';
import { LogsNav } from 'src/app/interfaces/interfaces.index';
import { LogsService, UserService } from 'src/app/services/services.index';

@Component({
  selector: 'app-capacidad-pago-opciones',
  templateUrl: './capacidad-pago-opciones.component.html',
  styleUrls: ['./capacidad-pago-opciones.component.css']
})
export class CapacidadPagoOpcionesComponent implements OnInit {

  actPetition: Petition;

  constructor(private router: Router,
    private logService: LogsService,
    private userService: UserService) { }

  ngOnInit(): void {
    this.addLogsNav();
    this.actPetition = (JSON.parse(sessionStorage.getItem('selPetition'))) as Petition;
  }
  onBack() {

    if(this.actPetition.process == 3 || this.actPetition.process == 4)
      this.router.navigate([`proceso-capacidad-pago`, 1]);
    else
      this.router.navigate([`proceso-capacidad-pago`, 2]);
  }

  addLogsNav(){
    const logNav: LogsNav = {
      logType: 'Log de Navegación',
      visitedPage: location.href,
      userId: this.userService.user.id,
      petitionId: 0,
      stepCompleted: ''
    };

  }
}
